<template>
  <div class="city_picker">
    <van-cell
      class="after_field_border"
      title="所在城市"
      is-link
      :value="cityFormat"
      @click="onShow"
    />
    <van-popup v-model="show" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-num="2"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Cell, Area, Popup } from 'vant'
import areaList from '@/utils/areaList'

export default {
  name: 'CityPicker',
  model: {
    prop: 'value',
    event: 'confirm'
  },
  props: {
    value: {
      type: String
    }
  },
  components: {
    [Cell.name]: Cell,
    [Area.name]: Area,
    [Popup.name]: Popup
  },
  data () {
    return {
      show: false,
      cityFormat: '',
      areaList: {}
    }
  },
  created () {
    this.cityFormat = this.value
    this.areaList = areaList
  },
  methods: {
    onShow () {
      this.show = true
    },
    onConfirm (value) {
      this.cityFormat = value[1].name
      this.$emit('confirm', value[1].name)
      this.show = false
    },
    onCancel () {
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
</style>
